interface CopyRichTextArgs {
  html: string;
  plainText: string;
}

export async function copyRichText({
  html,
  plainText
}: CopyRichTextArgs): Promise<void> {
  await navigator.clipboard.write([
    new ClipboardItem({
      "text/html": new Blob([html], { type: "text/html" }),
      "text/plain": new Blob([plainText], { type: "text/plain" })
    })
  ]);
}
